(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-360-video"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-360-video')) {
		class LTA360Video extends HTMLElement {
			constructor() {
				super()

				this._onClick = this._onClick.bind(this)
				this._onEnded = this._onEnded.bind(this)
			}

			connectedCallback() {
				this.addEventListener('click', this._onClick)
				// `ended` does not bubble — listen in the capture phase.
				this.addEventListener('ended', this._onEnded, true)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this._onClick)
				this.removeEventListener('ended', this._onEnded, true)
			}

			_onClick(event) {
				if (this.classList.contains('is-playing') || event.target.closest('a')) return

				this._play()
			}

			_play() {
				if (!this.playerEl) {
					const templateEl = this.querySelector('[data-360-video-template]')
					const mediaEl = this.querySelector('[data-360-video-media]')

					if (!templateEl || !mediaEl) return

					mediaEl.appendChild(templateEl.content.cloneNode(true))
					this.playerEl = mediaEl.querySelector('video, iframe')

					if (!this.playerEl) return
				}

				this.classList.add('is-playing')

				if (this.playerEl.tagName === 'VIDEO') {
					this.playerEl.play()?.catch(() => {})
				}

				this.playerEl.focus()
			}

			_onEnded() {
				this.classList.remove('is-playing')
				this.querySelector('[data-360-video-play]')?.focus()
			}
		}

		customElements.define('l-360-video', LTA360Video)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-age-gate"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-age-gate')) {
		class LTAAgeGate extends LTADrawer {
			connectedCallback() {
				super.connectedCallback()

				this.confirmEl = this.querySelector('[data-age-gate-confirm]')
				this.denyEl = this.querySelector('[data-age-gate-deny]')
				this.backEl = this.querySelector('[data-age-gate-back]')
				this.promptEl = this.querySelector('[data-age-gate-prompt]')
				this.deniedEl = this.querySelector('[data-age-gate-denied]')
				this.questionEl = this.querySelector('[id^="AgeGateQuestion-"]')
				this.deniedLabelEl = this.querySelector('[id^="AgeGateDenied-"]')
				this.storageKey = this.dataset.storageKey || 'l-age-gate-verified'
				this.storageType = this.dataset.storageType || 'daily'
				this.denyUrl = (this.dataset.denyUrl || '').trim()
				this.designMode = this.dataset.designMode === 'true'
				this.defaultElementToFocus = this.confirmEl

				this._onConfirm = this._onConfirm.bind(this)
				this._onDeny = this._onDeny.bind(this)
				this._onBack = this._onBack.bind(this)
				this._onSectionSelect = this._onSectionSelect.bind(this)
				this._onSectionDeselect = this._onSectionDeselect.bind(this)

				this.confirmEl?.addEventListener('click', this._onConfirm)
				this.denyEl?.addEventListener('click', this._onDeny)
				this.backEl?.addEventListener('click', this._onBack)

				if (this.designMode) {
					document.addEventListener('shopify:section:select', this._onSectionSelect)
					document.addEventListener('shopify:section:deselect', this._onSectionDeselect)
					return
				}

				if (!this._isVerified()) {
					requestAnimationFrame(() => this.drawer_open(this.confirmEl))
				}
			}

			disconnectedCallback() {
				this.confirmEl?.removeEventListener('click', this._onConfirm)
				this.denyEl?.removeEventListener('click', this._onDeny)
				this.backEl?.removeEventListener('click', this._onBack)

				if (this.designMode) {
					document.removeEventListener('shopify:section:select', this._onSectionSelect)
					document.removeEventListener('shopify:section:deselect', this._onSectionDeselect)
				}
			}

			_todayKey() {
				const d = new Date()
				return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
			}

			_isVerified() {
				try {
					if (this.storageType === 'session') {
						return sessionStorage.getItem(this.storageKey) === '1'
					}
					return localStorage.getItem(this.storageKey) === this._todayKey()
				} catch {
					return false
				}
			}

			_setVerified() {
				try {
					if (this.storageType === 'session') {
						sessionStorage.setItem(this.storageKey, '1')
					} else {
						localStorage.setItem(this.storageKey, this._todayKey())
					}
				} catch {}
			}

			_belongsToSection(sectionEl) {
				return Boolean(sectionEl?.contains?.(this))
			}

			_onSectionSelect(event) {
				if (!this._belongsToSection(event.target)) return
				this._showPrompt()
				this.drawer_open(this.confirmEl)
			}

			_onSectionDeselect(event) {
				if (!this._belongsToSection(event.target)) return
				this.drawer_close()
				this._resetToPrompt()
			}

			_resetToPrompt() {
				this.deniedEl?.classList.add('l-hidden')
				this.deniedEl?.setAttribute('hidden', '')
				this.promptEl?.classList.remove('l-hidden')
				this.promptEl?.removeAttribute('hidden')
				this._syncDialogLabel()
			}

			_syncDialogLabel() {
				const labelId = this.questionEl?.id || this.querySelector('[id^="AgeGateIntro-"]')?.id
				if (labelId) {
					this.setAttribute('aria-labelledby', labelId)
					return
				}
				this.removeAttribute('aria-labelledby')
			}

			_showDenied() {
				this.promptEl?.classList.add('l-hidden')
				this.promptEl?.setAttribute('hidden', '')
				this.deniedEl?.classList.remove('l-hidden')
				this.deniedEl?.removeAttribute('hidden')
				if (this.deniedLabelEl?.id) this.setAttribute('aria-labelledby', this.deniedLabelEl.id)
				this.backEl?.focus()
			}

			_showPrompt() {
				this._resetToPrompt()
				this.confirmEl?.focus()
			}

			drawer_open(triggerEl) {
				super.drawer_open(triggerEl)
				if (this.designMode) l_unLockBodyScroll(this.drawerName)
			}

			// Hard gate — no dismiss via backdrop or Escape
			drawer_closeOutsideOnClick() {}

			drawer_closeOutsideOnEscape() {}

			_onConfirm(event) {
				event.preventDefault()
				if (!this.designMode) this._setVerified()
				this.drawer_close()
			}

			_onDeny(event) {
				event.preventDefault()
				if (this.denyUrl && !this.designMode) {
					window.location.assign(this.denyUrl)
					return
				}
				this._showDenied()
			}

			_onBack(event) {
				event.preventDefault()
				this._showPrompt()
			}
		}

		customElements.define('l-age-gate', LTAAgeGate)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-announcement-bar"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-announcement-bar')) {
		class LTAAnnouncementBar extends HTMLElement {
			constructor() {
				super()
				this.handlePause = this.handlePause.bind(this)
				this.handleResume = this.handleResume.bind(this)
				this.handleVisibility = this.handleVisibility.bind(this)
				this.advance = this.advance.bind(this)
				this.updateBarHeight = this.updateBarHeight.bind(this)
			}

			// Lifecycle
			// -----------------------------------

			connectedCallback() {
				this.resizeObserver = new ResizeObserver(this.updateBarHeight)
				this.resizeObserver.observe(this)
				this.updateBarHeight()

				this.messages = [...this.querySelectorAll('[data-announcement-message]')]
				if (!this.messages.length) return

				this.index = 0
				this.timer = null
				this.paused = false
				this.shouldRotate = this.hasAttribute('data-rotate') && this.messages.length > 1

				this.classList.add('is-ready')

				if (!this.shouldRotate) return

				this.setActive(0)

				const parsed = Number.parseInt(this.getAttribute('data-interval'), 10)
				this.interval = Number.isFinite(parsed) && parsed >= 3000 ? parsed : 6000

				this.addEventListener('mouseenter', this.handlePause)
				this.addEventListener('mouseleave', this.handleResume)
				this.addEventListener('focusin', this.handlePause)
				this.addEventListener('focusout', this.handleResume)
				document.addEventListener('visibilitychange', this.handleVisibility)

				this.start()
			}

			disconnectedCallback() {
				this.stop()
				this.resizeObserver?.disconnect()
				this.removeEventListener('mouseenter', this.handlePause)
				this.removeEventListener('mouseleave', this.handleResume)
				this.removeEventListener('focusin', this.handlePause)
				this.removeEventListener('focusout', this.handleResume)
				document.removeEventListener('visibilitychange', this.handleVisibility)
			}

			updateBarHeight() {
				document.documentElement.style.setProperty('--l-announcement-bar-height', `${this.offsetHeight}px`)
			}

			// Rotation
			// -----------------------------------

			setActive(next) {
				this.messages.forEach((message, position) => {
					const isActive = position === next
					message.classList.toggle('is-active', isActive)
					message.toggleAttribute('inert', !isActive)
				})

				this.index = next
			}

			advance() {
				this.setActive((this.index + 1) % this.messages.length)
			}

			start() {
				if (!this.shouldRotate || this.paused || this.timer) return
				this.timer = window.setInterval(this.advance, this.interval)
			}

			stop() {
				if (!this.timer) return
				window.clearInterval(this.timer)
				this.timer = null
			}

			// Pause handlers
			// -----------------------------------

			handlePause(event) {
				if (event.type === 'focusin') this.focusPaused = true
				else this.hoverPaused = true
				this.paused = true
				this.stop()
			}

			handleResume(event) {
				if (event.type === 'focusout') this.focusPaused = false
				else this.hoverPaused = false
				if (this.focusPaused || this.hoverPaused) return
				this.paused = false
				if (!document.hidden) this.start()
			}

			handleVisibility() {
				if (document.hidden) {
					this.stop()

					return
				}

				if (!this.paused) this.start()
			}
		}

		customElements.define('l-announcement-bar', LTAAnnouncementBar)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-cart-drawer"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-cart-drawer')) {
		class LTACartDrawer extends LTADrawer {
			constructor() {
				super()

				this.updatedVariants = []
				this._onQuantityChange = l_debounce(this._onQuantityChange.bind(this), 200)
				this._onRemoveLineItem = this._onRemoveLineItem.bind(this)
				this._onCartUpdate = this._onCartUpdate.bind(this)
			}

			/* ---- lifecycle ---- */

			connectedCallback() {
				if (super.connectedCallback) super.connectedCallback()

				this.updatedVariants = []

				this.addEventListener('change', this._onQuantityChange)
				this.addEventListener('click', this._onRemoveLineItem)

				document.addEventListener('l:product:added', this._onCartUpdate)
				document.addEventListener('l:cart:error', this._onCartUpdate)
				document.addEventListener('l:cart:discount:applied', this._onCartUpdate)
			}

			disconnectedCallback() {
				if (super.disconnectedCallback) super.disconnectedCallback()
				if (this.classList.contains('is-active')) this.drawer_close()

				this.removeEventListener('change', this._onQuantityChange)
				this.removeEventListener('click', this._onRemoveLineItem)

				document.removeEventListener('l:product:added', this._onCartUpdate)
				document.removeEventListener('l:cart:error', this._onCartUpdate)
				document.removeEventListener('l:cart:discount:applied', this._onCartUpdate)
			}

			/* ---- drawer overrides ---- */

			drawer_close() {
				super.drawer_close()

				this.dispatchEvent(
					new CustomEvent('l:cart:closed', {
						bubbles: true,
						detail: { updatedVariants: this.updatedVariants },
					})
				)

				this.updatedVariants = []
			}

			drawer_open(triggerEl) {
				super.drawer_open(triggerEl)

				const focusReturnSelector = triggerEl?.dataset.drawerFocusReturnSelector
				const focusReturnEl = focusReturnSelector ? document.querySelector(focusReturnSelector) : null

				if (focusReturnEl) this.triggerEl = focusReturnEl
			}

			/* ---- line item events ---- */

			_onRemoveLineItem(event) {
				const removeBtn = event.target.closest('[data-remove-line-item]')
				if (!removeBtn) return

				event.preventDefault()

				const lineItemEl = event.target.closest('[data-drawer-line-item]')
				if (lineItemEl) this._updateCartLine(lineItemEl, 0)
			}

			_onQuantityChange(event) {
				const inputEl = event.target.closest('[data-quantity-input]')
				const lineItemEl = event.target.closest('[data-drawer-line-item]')
				if (!inputEl || !lineItemEl) return

				let quantity = parseInt(inputEl.value, 10)
				if (isNaN(quantity)) {
					inputEl.value = inputEl.defaultValue

					return
				}

				const max = parseInt(inputEl.max, 10)
				if (!isNaN(max)) quantity = Math.min(quantity, max)

				this._updateCartLine(lineItemEl, Math.max(quantity, 0))
			}

			/* ---- cart requests ---- */

			_updateCartLine(lineItemEl, quantity) {
				if (!lineItemEl) return

				this.classList.add('is-loading')
				this._toggleLineError(lineItemEl, false)

				const line = parseInt(lineItemEl.dataset.index, 10)
				const variantId = lineItemEl.dataset.variantId

				ltaCartService
					.changeCartLineItem({
						line,
						quantity,
						sections_url: window.location.pathname,
						sections: this._getSectionsToRender().map((section) => section.id),
					})
					.then(async (cart) => {
						if (cart?.status === 422) {
							this._handleCartError(cart, lineItemEl)

							return
						}

						this._updateCartData(await this._withRecommendations(cart.sections[this.dataset.sectionId]))

						this.dispatchEvent(new CustomEvent('l:cart:updated', { detail: { cart }, bubbles: true }))
						this.updatedVariants.push(variantId)
					})
					.catch((error) => {
						console.error(error)
					})
					.finally(() => {
						this.classList.remove('is-loading')
					})
			}

			_handleCartError(error = { description: '' }, lineItemEl) {
				const inputEl = lineItemEl.querySelector('[data-quantity-input]')
				if (inputEl) inputEl.value = inputEl.defaultValue

				const errorMessageEl = lineItemEl.querySelector('[data-error-message]')
				if (errorMessageEl) errorMessageEl.textContent = error.description

				this._toggleLineError(lineItemEl, true)
			}

			_toggleLineError(lineItemEl, isVisible) {
				lineItemEl.querySelector('[data-error-message]')?.parentElement.classList.toggle('l-hidden', !isVisible)
			}

			_onCartUpdate(event) {
				if (event?.type === 'l:cart:error' && event.detail?.id === 'l-product-form') return
				if (event?.type === 'l:product:added')
					customElements.get('l-cart-upsell')?.saveLastAdded(event.detail?.response)

				const activeElement = document.activeElement
				const activeElementIsUsable =
					activeElement instanceof HTMLElement &&
					activeElement !== document.body &&
					!activeElement.closest('[aria-hidden="true"]')
				const visibleTrigger = [...(this.triggerEls || [])].find((triggerEl) => triggerEl.offsetParent !== null)
				const triggerEl = activeElementIsUsable ? activeElement : visibleTrigger

				if (!this.classList.contains('is-active')) this.drawer_open(triggerEl)
				this.classList.add('is-loading')

				const sectionsUrl = this.dataset.sectionsUrl || window.LTATheme.routes.root

				fetch(`${sectionsUrl}?section_id=${this.dataset.sectionId}`)
					.then((res) => {
						if (!res.ok) throw new Error(`Cart drawer section request failed with status ${res.status}`)

						return res.text()
					})
					.then((html) => this._withRecommendations(html))
					.then((html) => {
						this._updateCartData(html)
					})
					.catch((error) => {
						console.error(error)
					})
					.finally(() => {
						this.classList.remove('is-loading')
					})
			}

			/* ---- section render ---- */

			async _withRecommendations(html) {
				const CartUpsell = customElements.get('l-cart-upsell')
				if (!html || !CartUpsell) return html

				const doc = new DOMParser().parseFromString(html, 'text/html')
				const upsellEl = doc.querySelector('l-cart-upsell:not([data-loaded])')
				const url = upsellEl ? CartUpsell.getUrl(upsellEl) : null
				if (!url) return html

				try {
					const res = await fetch(url)
					if (!res.ok) throw new Error(`Cart upsell request failed with status ${res.status}`)

					const recommendationsHTML = await res.text()

					return recommendationsHTML.includes('data-cart-drawer') ? recommendationsHTML : html
				} catch (error) {
					console.error(error)

					return html
				}
			}

			_updateCartData(html) {
				const newCartDrawerHTML = l_getSectionDOM(html, '[data-cart-drawer]')
				if (!newCartDrawerHTML) return

				if (!this.classList.contains('is-active')) this.drawer_open()

				this.classList.toggle('is-empty', newCartDrawerHTML.classList.contains('is-empty'))

				const selectors = ['[data-drawer-header]', '[data-cart-inner]', '[data-cart-footer]']

				selectors.forEach((selector) => {
					const newSection = newCartDrawerHTML.querySelector(selector)
					const oldSection = this.querySelector(selector)

					if (newSection && oldSection) {
						oldSection.innerHTML = newSection.innerHTML
						oldSection.classList.remove('l-hidden')
					}
					if (!newSection) oldSection?.classList.add('l-hidden')
				})
			}

			_getSectionsToRender() {
				return [
					{
						id: this.dataset.sectionId,
						selector: '.shopify-section',
					},
				]
			}
		}

		customElements.define('l-cart-drawer', LTACartDrawer)
	}

	if (!customElements.get('l-cart-upsell')) {
		class LTACartUpsell extends HTMLElement {
			static storageKey = 'l-cart-last-added'

			static saveLastAdded(response) {
				const productId = response?.product_id || response?.items?.[0]?.product_id
				if (!productId) return

				try {
					sessionStorage.setItem(this.storageKey, String(productId))
				} catch (error) {
					console.error(error)
				}
			}

			static getUrl(hostEl) {
				const { url, productId, cartProductIds = '' } = hostEl.dataset
				if (!url) return null

				let seedId = productId

				try {
					const lastAddedId = sessionStorage.getItem(this.storageKey)
					if (lastAddedId && cartProductIds.split(',').includes(lastAddedId)) seedId = lastAddedId
				} catch (error) {
					console.error(error)
				}

				return seedId ? `${url}&product_id=${seedId}` : null
			}

			connectedCallback() {
				if (this.hasAttribute('data-loaded')) return

				this._load()
			}

			async _load() {
				const url = LTACartUpsell.getUrl(this)
				if (!url) return

				this.setAttribute('data-loaded', '')

				try {
					const res = await fetch(url)
					if (!res.ok) throw new Error(`Cart upsell request failed with status ${res.status}`)

					const doc = new DOMParser().parseFromString(await res.text(), 'text/html')
					const nextEl = doc.querySelector('l-cart-upsell')

					if (nextEl && this.isConnected) this.innerHTML = nextEl.innerHTML
				} catch (error) {
					console.error('[l-cart-upsell] failed:', error)
				}
			}
		}

		customElements.define('l-cart-upsell', LTACartUpsell)
	}

	if (!customElements.get('l-shipping-bar')) {
		class LTAShippingBar extends HTMLElement {
			constructor() {
				super()

				this.elements = {}
			}

			connectedCallback() {
				this._cacheElements()
				this._render()
			}

			_cacheElements() {
				this.elements = {
					label: this.querySelector('[data-label]'),
					progressBar: this.querySelector('[data-progress-bar]'),
					srOnly: this.querySelector('[data-sr-only]'),
				}
			}

			_getCartData() {
				const ds = this.dataset

				return {
					cartTotal: parseFloat(ds.cartTotal),
					thresholdAmount: parseFloat(ds.thresholdAmount),
					cartCurrency: ds.cartCurrency,
					shopCurrency: ds.shopCurrency,
					progressMessage: ds.progressMessage,
					successMessage: ds.successMessage,
				}
			}

			_getProgressData({ cartTotal, thresholdAmount, shopCurrency, cartCurrency }) {
				const convertedThreshold = Currency.convert(thresholdAmount, shopCurrency, cartCurrency)
				const remaining = Math.max(0, convertedThreshold - cartTotal)
				const progress = convertedThreshold ? Math.min((cartTotal / convertedThreshold) * 100, 100) : 0

				return { progress, remaining, convertedThreshold }
			}

			_render() {
				const { label, progressBar, srOnly } = this.elements
				const cartData = this._getCartData()

				if (isNaN(cartData.cartTotal) || isNaN(cartData.thresholdAmount) || !progressBar || !label || !srOnly) {
					return
				}

				const { progress, remaining } = this._getProgressData(cartData)

				progressBar.style.setProperty('--l-progress-bar-width', `${progress}%`)
				const remainingMoney = l_formatMoney(remaining)
				label.innerHTML =
					progress < 100
						? cartData.progressMessage.replace('[money]', remainingMoney).replace('[MONEY]', remainingMoney)
						: cartData.successMessage
				progressBar.setAttribute('aria-valuenow', progress.toFixed(0))
				srOnly.textContent = `${progress.toFixed(0)}%`
			}
		}

		customElements.define('l-shipping-bar', LTAShippingBar)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-blog"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-main-blog')) {
		class LTAMainBlog extends HTMLElement {
			constructor() {
				super()
				this.cache = new Map()
				this.loadId = 0
				this.onPrefetch = this.onPrefetch.bind(this)
				this.onClick = this.onClick.bind(this)
				this.onPopState = this.onPopState.bind(this)
				this.onFilterChange = this.onFilterChange.bind(this)
				this.onFilterClick = this.onFilterClick.bind(this)
				this.onPageClick = this.onPageClick.bind(this)
				this.onSearchInput = this.onSearchInput.bind(this)
			}

			connectedCallback() {
				this.sectionId = this.dataset.sectionId
				this.isFilterMode = this.hasAttribute('data-filter-mode')

				if (this.isFilterMode) {
					this.initFilters()
					return
				}

				this.addEventListener('pointerenter', this.onPrefetch, true)
				this.addEventListener('focusin', this.onPrefetch)
				this.addEventListener('touchstart', this.onPrefetch, { passive: true })
				this.addEventListener('click', this.onClick)
				window.addEventListener('popstate', this.onPopState)
			}

			disconnectedCallback() {
				if (this.isFilterMode) {
					this.drawerEl?.removeEventListener('change', this.onFilterChange)
					this.drawerEl?.removeEventListener('click', this.onFilterClick)
					this.paginationEl?.removeEventListener('click', this.onPageClick)
					this.searchEl?.removeEventListener('input', this.onSearchInput)
					return
				}

				this.removeEventListener('pointerenter', this.onPrefetch, true)
				this.removeEventListener('focusin', this.onPrefetch)
				this.removeEventListener('touchstart', this.onPrefetch)
				this.removeEventListener('click', this.onClick)
				window.removeEventListener('popstate', this.onPopState)
			}

			/* Filter mode: OR within a group, AND across groups */

			initFilters() {
				this.drawerEl = document.getElementById(this.dataset.drawerId)
				this.paginationEl = this.querySelector('[data-blog-pagination]')
				this.emptyEl = this.querySelector('[data-blog-filter-empty]')
				this.cardEls = [...this.querySelectorAll('[data-blog-card]')]
				this.cardTags = new Map(
					this.cardEls.map((cardEl) => [cardEl, (cardEl.dataset.filterTags || '').split(',').filter(Boolean)])
				)
				this.cardTitles = new Map(
					this.cardEls.map((cardEl) => [cardEl, this.normalizeText(cardEl.dataset.filterTitle)])
				)
				this.searchEl = this.drawerEl?.querySelector('[data-blog-filter-search]')
				this.perPage = parseInt(this.dataset.perPage, 10) || 12
				this.page = 1

				this.drawerEl?.addEventListener('change', this.onFilterChange)
				this.drawerEl?.addEventListener('click', this.onFilterClick)
				this.paginationEl?.addEventListener('click', this.onPageClick)
				this.searchEl?.addEventListener('input', this.onSearchInput)

				this.readFilterState()
				this.applyFilters({ syncUrl: false })
				this.setAttribute('data-ready', '')
			}

			getFilterInputs() {
				return this.drawerEl ? [...this.drawerEl.querySelectorAll('[data-blog-filter-input]')] : []
			}

			normalizeText(text = '') {
				return text
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
					.trim()
			}

			getSearchWords() {
				return this.searchEl ? this.normalizeText(this.searchEl.value).split(/\s+/).filter(Boolean) : []
			}

			readFilterState() {
				const params = new URL(window.location.href).searchParams
				const query = params.get('q')
				if (query && this.searchEl) this.searchEl.value = query

				const param = params.get('filter')
				if (!param) return

				const handles = new Set(param.split(',').filter(Boolean))
				this.getFilterInputs().forEach((inputEl) => {
					inputEl.checked = handles.has(inputEl.value)
				})
			}

			getActiveGroups() {
				const groups = new Map()

				this.getFilterInputs().forEach((inputEl) => {
					if (!inputEl.checked) return
					if (!groups.has(inputEl.dataset.group)) groups.set(inputEl.dataset.group, new Set())
					groups.get(inputEl.dataset.group).add(inputEl.value)
				})

				return groups
			}

			applyFilters({ syncUrl = true } = {}) {
				const groups = [...this.getActiveGroups().values()]
				const words = this.getSearchWords()
				const hasActive = groups.length > 0 || words.length > 0

				this.matchedEls = this.cardEls.filter((cardEl) => {
					const tags = this.cardTags.get(cardEl)
					const title = this.cardTitles.get(cardEl)
					return (
						groups.every((handles) => tags.some((tag) => handles.has(tag))) &&
						words.every((word) => title.includes(word))
					)
				})
				this.page = 1
				this.renderPage()

				if (this.emptyEl) this.emptyEl.hidden = !this.cardEls.length || this.matchedEls.length > 0

				const clearEl = this.drawerEl?.querySelector('[data-blog-filter-clear]')
				if (clearEl) {
					clearEl.classList.toggle('is-disabled', !hasActive)
					clearEl.setAttribute('aria-disabled', hasActive ? 'false' : 'true')
				}

				if (syncUrl) this.syncFilterUrl()
			}

			syncFilterUrl() {
				const url = new URL(window.location.href)
				const handles = this.getFilterInputs()
					.filter((inputEl) => inputEl.checked)
					.map((inputEl) => inputEl.value)

				if (handles.length) url.searchParams.set('filter', [...new Set(handles)].join(','))
				else url.searchParams.delete('filter')

				const query = this.searchEl?.value.trim()
				if (query) url.searchParams.set('q', query)
				else url.searchParams.delete('q')

				window.history.replaceState(window.history.state, '', url.toString())
			}

			onFilterChange(event) {
				if (!(event.target instanceof Element) || !event.target.matches('[data-blog-filter-input]')) return
				this.applyFilters()
			}

			onFilterClick(event) {
				if (!(event.target instanceof Element)) return

				const clearEl = event.target.closest('[data-blog-filter-clear]')
				if (!clearEl || clearEl.classList.contains('is-disabled')) return

				this.getFilterInputs().forEach((inputEl) => {
					inputEl.checked = false
				})
				if (this.searchEl) this.searchEl.value = ''
				this.applyFilters()
			}

			onSearchInput() {
				this.applyFilters()
			}

			renderPage() {
				const start = (this.page - 1) * this.perPage
				const visibleEls = new Set(this.matchedEls.slice(start, start + this.perPage))

				this.cardEls.forEach((cardEl) => {
					cardEl.hidden = !visibleEls.has(cardEl)
				})

				this.renderPagination()
			}

			getPageParts(total) {
				const parts = []
				const windowStart = Math.max(2, this.page - 1)
				const windowEnd = Math.min(total - 1, this.page + 1)

				parts.push(1)
				if (windowStart > 2) parts.push(null)
				for (let page = windowStart; page <= windowEnd; page++) parts.push(page)
				if (windowEnd < total - 1) parts.push(null)
				if (total > 1) parts.push(total)

				return parts
			}

			renderPagination() {
				if (!this.paginationEl) return

				const total = Math.ceil(this.matchedEls.length / this.perPage)
				if (total <= 1) {
					this.paginationEl.innerHTML = ''
					return
				}

				const labels = this.paginationEl.dataset
				const linkClass = 'l-cPagination__link l-relative l-inline-flex-center l-text l-uppercase l-text-center'
				const href = `#${this.querySelector('[data-blog-grid]')?.id || ''}`
				const prevIcon =
					'<svg aria-hidden="true" focusable="false" width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="l-cPagination__icon"><path d="M5.80078 0.384766L0.800781 4.53477L5.80078 8.38477" stroke="currentColor"/></svg>'
				const nextIcon =
					'<svg aria-hidden="true" focusable="false" width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="l-cPagination__icon"><path d="M0.318359 0.384766L5.31836 4.53477L0.318359 8.38477" stroke="currentColor"/></svg>'

				const arrow = (page, icon, label, isLink) =>
					isLink
						? `<li class="l-flex"><a href="${href}" class="${linkClass}" data-page="${page}">${icon}<span class="l-sr-only">${label}</span></a></li>`
						: `<li class="l-flex"><span class="${linkClass} is-disabled">${icon}<span class="l-sr-only">${label}</span></span></li>`

				const items = this.getPageParts(total).map((page) => {
					if (page === null) return `<li class="l-flex" aria-hidden="true"><span class="${linkClass} is-gap">&hellip;</span></li>`
					if (page === this.page) {
						return `<li class="l-flex"><span class="${linkClass} is-current" aria-current="page"><span class="l-sr-only">${labels.labelPage}</span>${page}</span></li>`
					}
					return `<li class="l-flex"><a href="${href}" class="${linkClass}" data-page="${page}"><span class="l-sr-only">${labels.labelPage}</span>${page}</a></li>`
				})

				this.paginationEl.innerHTML = `<nav class="l-cPagination" aria-label="${labels.label}"><ul class="l-cPagination__list l-flex-center" role="list">${arrow(
					this.page - 1,
					prevIcon,
					labels.labelPrevious,
					this.page > 1
				)}${items.join('')}${arrow(this.page + 1, nextIcon, labels.labelNext, this.page < total)}</ul></nav>`
			}

			onPageClick(event) {
				if (!(event.target instanceof Element)) return

				const linkEl = event.target.closest('[data-page]')
				if (!linkEl) return

				event.preventDefault()
				this.page = parseInt(linkEl.dataset.page, 10) || 1
				this.renderPage()

				const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
				const firstCardEl = this.matchedEls[(this.page - 1) * this.perPage]
				firstCardEl?.querySelector('a[href]:not([tabindex="-1"])')?.focus({ preventScroll: true })
				const sectionEl = this.closest('.shopify-section') || this
				sectionEl.scrollIntoView({
					behavior: reduceMotion ? 'instant' : 'smooth',
					block: 'start',
				})
			}

			/* AJAX pagination (no Filters block) */

			getLink(event) {
				if (!(event.target instanceof Element)) return null
				return event.target.closest('[data-pagination-link]')
			}

			getSectionUrl(url) {
				const sectionUrl = new URL(url, window.location.origin)
				sectionUrl.searchParams.set('section_id', this.sectionId)
				sectionUrl.hash = ''
				return sectionUrl.toString()
			}

			getCleanUrl(url) {
				const cleanUrl = new URL(url, window.location.origin)
				cleanUrl.searchParams.delete('section_id')
				cleanUrl.hash = ''
				return cleanUrl.toString()
			}

			fetchPage(url) {
				const key = this.getSectionUrl(url)

				if (!this.cache.has(key)) {
					const request = fetch(key).then((response) => {
						if (!response.ok) throw new Error(`HTTP ${response.status}`)
						return response.text()
					})

					request.catch(() => this.cache.delete(key))
					this.cache.set(key, request)
				}

				return this.cache.get(key)
			}

			onPrefetch(event) {
				const link = this.getLink(event)
				if (link) this.fetchPage(link.href).catch(() => {})
			}

			onClick(event) {
				const link = this.getLink(event)
				if (!link || event.defaultPrevented) return
				if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

				event.preventDefault()
				this.load(link.href)
			}

			onPopState() {
				this.load(window.location.href, { push: false })
			}

			setLoading(isLoading) {
				const gridEl = this.querySelector('[data-blog-grid]')
				if (!gridEl) return

				gridEl.classList.toggle('is-loading', isLoading)
				gridEl.toggleAttribute('aria-busy', isLoading)
			}

			async load(url, { push = true, focusGrid = true } = {}) {
				const loadId = ++this.loadId
				this.setLoading(true)

				try {
					const html = await this.fetchPage(url)
					if (loadId !== this.loadId) return

					const doc = new DOMParser().parseFromString(html, 'text/html')
					const gridEl = this.querySelector('[data-blog-grid]')
					const paginationEl = this.querySelector('[data-blog-pagination]')
					const newGridEl = doc.querySelector('[data-blog-grid]')
					const newPaginationEl = doc.querySelector('[data-blog-pagination]')

					if (!gridEl || !paginationEl || !newGridEl || !newPaginationEl) {
						throw new Error('Missing blog hooks')
					}

					gridEl.innerHTML = newGridEl.innerHTML
					paginationEl.innerHTML = newPaginationEl.innerHTML

					if (!push) return

					const cleanUrl = this.getCleanUrl(url)
					window.history.pushState({ mainBlog: cleanUrl }, '', cleanUrl)

					if (!focusGrid) return

					const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
					gridEl.querySelector('a[href]:not([tabindex="-1"])')?.focus({ preventScroll: true })
					const sectionEl = this.closest('.shopify-section') || this
					sectionEl.scrollIntoView({
						behavior: reduceMotion ? 'instant' : 'smooth',
						block: 'start',
					})
				} catch (error) {
					if (loadId === this.loadId) window.location.href = url
				} finally {
					if (loadId === this.loadId) this.setLoading(false)
				}
			}
		}

		customElements.define('l-main-blog', LTAMainBlog)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-cart"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-main-cart')) {
		class LTAMainCart extends HTMLElement {
			constructor() {
				super()

				this._onQuantityChange = l_debounce(this._onQuantityChange.bind(this), 200)
				this._onRemoveLineItem = this._onRemoveLineItem.bind(this)
				this._onCartUpdate = this._onCartUpdate.bind(this)
			}

			/* ---- lifecycle ---- */

			connectedCallback() {
				this.addEventListener('change', this._onQuantityChange)
				this.addEventListener('click', this._onRemoveLineItem)

				document.addEventListener('l:product:added', this._onCartUpdate)
				document.addEventListener('l:cart:error', this._onCartUpdate)
				document.addEventListener('l:cart:discount:applied', this._onCartUpdate)
			}

			disconnectedCallback() {
				this.removeEventListener('change', this._onQuantityChange)
				this.removeEventListener('click', this._onRemoveLineItem)

				document.removeEventListener('l:product:added', this._onCartUpdate)
				document.removeEventListener('l:cart:error', this._onCartUpdate)
				document.removeEventListener('l:cart:discount:applied', this._onCartUpdate)
			}

			/* ---- line item events ---- */

			_onRemoveLineItem(event) {
				const removeBtn = event.target.closest('[data-remove-line-item]')
				if (!removeBtn) return

				event.preventDefault()

				const lineItemEl = removeBtn.closest('[data-cart-line-item]')
				if (lineItemEl) this._updateCartLine(lineItemEl, 0)
			}

			_onQuantityChange(event) {
				const inputEl = event.target.closest('[data-quantity-input]')
				const lineItemEl = event.target.closest('[data-cart-line-item]')
				if (!inputEl || !lineItemEl) return

				let quantity = parseInt(inputEl.value, 10)
				if (isNaN(quantity)) {
					inputEl.value = inputEl.defaultValue

					return
				}

				const max = parseInt(inputEl.max, 10)
				if (!isNaN(max)) quantity = Math.min(quantity, max)

				this._updateCartLine(lineItemEl, Math.max(quantity, 0))
			}

			/* ---- cart requests ---- */

			_updateCartLine(lineItemEl, quantity) {
				this._setLoading(true)
				this._toggleLineError(lineItemEl, false)

				ltaCartService
					.changeCartLineItem({
						line: parseInt(lineItemEl.dataset.index, 10),
						quantity,
						sections_url: window.location.pathname,
						sections: [this.dataset.sectionId],
					})
					.then((cart) => {
						if (cart?.status === 422) {
							this._handleCartError(cart, lineItemEl)

							return
						}

						this._updateCartData(cart.sections[this.dataset.sectionId])

						this.dispatchEvent(new CustomEvent('l:cart:updated', { detail: { cart }, bubbles: true }))
					})
					.catch((error) => {
						console.error(error)
					})
					.finally(() => {
						this._setLoading(false)
					})
			}

			_handleCartError(error, lineItemEl) {
				lineItemEl.querySelectorAll('[data-quantity-input]').forEach((inputEl) => {
					inputEl.value = inputEl.defaultValue
				})

				const errorMessageEl = lineItemEl.querySelector('[data-error-message]')
				if (errorMessageEl && error?.description) errorMessageEl.textContent = error.description

				this._toggleLineError(lineItemEl, true)
			}

			_toggleLineError(lineItemEl, isVisible) {
				lineItemEl.querySelector('[data-error-message]')?.parentElement.classList.toggle('l-hidden', !isVisible)
			}

			_onCartUpdate(event) {
				if (event?.type === 'l:cart:error' && event.detail?.id === 'l-product-form') return

				this._setLoading(true)

				fetch(`${window.LTATheme.routes.cart_url}?section_id=${this.dataset.sectionId}`)
					.then((res) => {
						if (!res.ok) throw new Error(`Main cart section request failed with status ${res.status}`)

						return res.text()
					})
					.then((html) => {
						this._updateCartData(html)
					})
					.catch((error) => {
						console.error(error)
					})
					.finally(() => {
						this._setLoading(false)
					})
			}

			/* ---- render ---- */

			_setLoading(isLoading) {
				this.classList.toggle('is-loading', isLoading)
				this.setAttribute('aria-busy', String(isLoading))
			}

			_updateCartData(html) {
				const newCartEl = l_getSectionDOM(html, '#main-cart')
				if (!newCartEl) return

				const isEmpty = newCartEl.classList.contains('is-empty')
				if (isEmpty !== this.classList.contains('is-empty')) {
					this.classList.toggle('is-empty', isEmpty)
					this.innerHTML = newCartEl.innerHTML

					return
				}

				const selectors = ['[data-cart-inner]', '[data-cart-footer]']
				if (this._upsellChanged(newCartEl)) selectors.push('[data-cart-bottom]')

				selectors.forEach((selector) => {
					const newSection = newCartEl.querySelector(selector)
					const oldSection = this.querySelector(selector)

					if (newSection && oldSection) oldSection.innerHTML = newSection.innerHTML
				})
			}

			_upsellChanged(newCartEl) {
				const oldUpsell = this.querySelector('l-cart-upsell')
				const newUpsell = newCartEl.querySelector('l-cart-upsell')

				return oldUpsell?.dataset.cartProductIds !== newUpsell?.dataset.cartProductIds
			}
		}

		customElements.define('l-main-cart', LTAMainCart)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-main-product"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-info')) {
		customElements.define(
			'l-product-info',
			class LProductInfo extends HTMLElement {
				quantityInput = undefined
				quantityForm = undefined
				abortController = undefined
				pendingRequestUrl = null
				preProcessHtmlCallbacks = []
				postProcessHtmlCallbacks = []

				constructor() {
					super()
				}

				connectedCallback() {
					this.productFormEl = this.querySelector('l-product-form')
					this.initializeProductSwapUtility()
					this.selectedSellingPlanId = this.dataset.sellingPlanId
					this.productId = this.dataset.productId

					this.dispatchEvent(new CustomEvent('l:product-info:loaded', { bubbles: true }))
					this.setupEventListeners()
				}

				// Option, selling plan, and cart qty all refetch this section so price / ATC / pickers stay in sync.
				setupEventListeners() {
					document.addEventListener('l:variant:option-changed', (event) => {
						const { target, selectedOptionValues, productId, sectionId, focusTargetId } = event.detail

						if (!this.contains(target) || productId !== this.productId || sectionId !== this.sectionId) return

						this.handleOptionValueChange(target, selectedOptionValues, null, focusTargetId)
					})

					document.addEventListener('l:sellingPlan:changed', (event) => {
						const { sellingPlanId, productId, sectionId, target, syncOnly } = event.detail

						if (!this.contains(target) || productId !== this.productId || sectionId !== this.sectionId) return

						const variant = this.getSelectedVariant(this)

						this.selectedSellingPlanId = sellingPlanId

						if (syncOnly) {
							this.updateURL(this.dataset.url, variant?.id)
							return
						}

						this.handleOptionValueChange(event.target, null, variant)
					})

					document.addEventListener('l:product:added', (event) => {
						const { response: addedVariant } = event.detail
						const currentVariant = this.getSelectedVariant(this)

						if (addedVariant?.id == currentVariant?.id) {
							this.handleOptionValueChange(null, null, currentVariant)
						}
					})

					// Dawn: product-info subscribes to cartUpdate → fetchQuantityRules.
					// Cart qty / remove fires l:cart:updated (l:cart:closed has no detail).
					document.addEventListener('l:cart:updated', () => {
						const variant = this.getSelectedVariant(this)
						if (!variant?.id) return

						this.handleOptionValueChange(null, null, variant)
					})
				}

				addPreProcessCallback(callback) {
					this.preProcessHtmlCallbacks.push(callback)
				}

				initializeProductSwapUtility() {
					this.postProcessHtmlCallbacks.push((newNode) => {
						window?.Shopify?.PaymentButton?.init()
						window?.ProductModel?.loadShopifyXR()
					})
				}

				// Complementary products change `productUrl` → swap the host; same product → patch pickers + sections.
				handleOptionValueChange(target, selectedOptionValues, variant, focusTargetId) {
					this.resetProductFormState()

					const productUrl = target?.dataset?.productUrl || this.pendingRequestUrl || this.dataset.url
					this.pendingRequestUrl = productUrl
					const shouldSwapProduct = this.dataset.url !== productUrl
					const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct

					this.renderProductInfo({
						requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, variant, shouldFetchFullPage),
						targetId: focusTargetId || target?.id,
						callback: shouldSwapProduct
							? this.handleSwapProduct(productUrl, shouldFetchFullPage)
							: this.handleUpdateProductInfo(productUrl),
					})
				}

				resetProductFormState() {
					if (this.productFormEl) {
						this.productFormEl.global_toggleSubmitButton(true, null, false)
						this.productFormEl.handleErrorMessage()
					}
				}

				renderProductInfo({ requestUrl, targetId, callback }) {
					this.abortController?.abort()
					this.abortController = new AbortController()

					fetch(requestUrl, { signal: this.abortController.signal })
						.then((response) => response.text())
						.then((responseText) => {
							this.pendingRequestUrl = null

							const html = new DOMParser().parseFromString(responseText, 'text/html')

							callback(html)
						})
						.then(() => {
							if (!targetId) return

							document.getElementById(targetId)?.focus()
						})
						.catch((error) => {
							if (error.name !== 'AbortError') {
								console.error('Product info fetch error:', error)
							}
						})
				}

				handleSwapProduct(productUrl, updateFullPage) {
					return (html) => {
						const variant = this.getSelectedVariant(html.querySelector('l-product-info'))

						this.updateURL(productUrl, variant?.id)

						if (updateFullPage) {
							document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML

							l_swapHtmlNode(
								document.querySelector('main'),
								html.querySelector('main'),
								this.preProcessHtmlCallbacks,
								this.postProcessHtmlCallbacks
							)
						} else {
							l_swapHtmlNode(
								this,
								html.querySelector('l-product-info'),
								this.preProcessHtmlCallbacks,
								this.postProcessHtmlCallbacks
							)
						}
					}
				}

				handleUpdateProductInfo(productUrl) {
					return (html) => {
						const variant = this.getSelectedVariant(html)

						this.updateOptionValues(html)
						this.updateURL(productUrl, variant?.id)
						this.updateVariantInputs(variant?.id)

						if (!variant) {
							document.dispatchEvent(
								new CustomEvent('l:variant:changed', {
									detail: { sectionId: this.sectionId, html, productId: this.dataset.productId, variant },
								})
							)

							return
						}

						this.updateProductSections(html)

						document.dispatchEvent(
							new CustomEvent('l:variant:changed', {
								detail: { sectionId: this.sectionId, html, productId: this.dataset.productId, variant },
							})
						)
					}
				}

				updateProductSections(html) {
					const updateSourceFromDestination = (id, htmlMethod = 'innerHTML', shouldHide = () => false) => {
						const source = html.getElementById(`${id}-${this.sectionId}`)
						const destination = document.getElementById(`${id}-${this.dataset.section}`)

						if (source && destination) {
							destination[htmlMethod] = source[htmlMethod]
							destination.classList.toggle('l-hidden', shouldHide(source))
						}
					}

					updateSourceFromDestination('stockInfo', 'outerHTML')
					updateSourceFromDestination('stickyATC', 'outerHTML')
				}

				updateOptionValues(html) {
					const variantSelects = html.querySelector('l-variant-selects')

					if (variantSelects) {
						l_swapHtmlNode(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks)
					}
				}

				updateURL(url, variantId) {
					if (this.dataset.updateUrl === 'false') return

					const currentUrlParams = new URLSearchParams(window.location.search)
					const params = new URLSearchParams()

					if (variantId) params.append('variant', variantId)

					if (this.selectedSellingPlanId) params.append('selling_plan', this.selectedSellingPlanId)

					const viewTemplate = currentUrlParams.get('view')

					if (viewTemplate) params.append('view', viewTemplate)

					const newUrl = `${url}${params.size > 0 ? '?' : ''}${params.toString()}`

					window.history.replaceState({}, '', newUrl)
				}

				updateVariantInputs(variantId) {
					this.querySelectorAll(`#product-form-${this.dataset.section}`).forEach((productForm) => {
						const input = productForm.querySelector('input[name="id"]')

						input.value = variantId ?? ''
						input.dispatchEvent(new Event('change', { bubbles: true }))
					})
				}

				getSelectedVariant(productInfoNode) {
					if (!productInfoNode) return null

					/* Picker JSON first; section-level JSON only when no variant picker block exists */
					const selectedVariant = (
						productInfoNode.querySelector('l-variant-selects [data-selected-variant]') ||
						productInfoNode.querySelector('[data-selected-variant]')
					)?.innerHTML

					return selectedVariant ? JSON.parse(selectedVariant) : null
				}

				buildRequestUrlWithParams(url, optionValues, variant, shouldFetchFullPage = false) {
					const params = []

					if (!shouldFetchFullPage) {
						params.push(`section_id=${this.sectionId}`)
					}

					if (this.selectedSellingPlanId) {
						params.push(`selling_plan=${this.selectedSellingPlanId}`)
					}

					if (optionValues?.length) {
						params.push(`option_values=${optionValues.join(',')}`)
					} else if (variant) {
						params.push(`variant=${variant.id}`)
					}

					return `${url}?${params.join('&')}`
				}

				get productForm() {
					return this.querySelector('l-product-form')
				}

				get variantSelectors() {
					return this.querySelector('l-variant-selects')
				}

				get sectionId() {
					return this.dataset.originalSection || this.dataset.section
				}
			}
		)
	}

	if (!customElements.get('l-product-media-gallery')) {
		customElements.define(
			'l-product-media-gallery',
			class LTAProductMediaGallery extends HTMLElement {
				constructor() {
					super()

					this._onVariantChange = this._onVariantChange.bind(this)
					this._onCarouselLoaded = this._onCarouselLoaded.bind(this)
					this._onModelLoaded = this._onModelLoaded.bind(this)
					this._cleanups = []
				}

				connectedCallback() {
					this._cacheEls()

					document.addEventListener('l:variant:changed', this._onVariantChange)
					this.addEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded)
					this.addEventListener('l:product-model:loaded', this._onModelLoaded)
					this._cleanups.push(
						() => document.removeEventListener('l:variant:changed', this._onVariantChange),
						() => this.removeEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded),
						() => this.removeEventListener('l:product-model:loaded', this._onModelLoaded)
					)

					if (this.carouselEl?.swiperCarousel) this._bindSwiper()
				}

				disconnectedCallback() {
					this._cleanups.forEach((fn) => fn())
					this._cleanups = []
				}

				get swiper() {
					return this.carouselEl?.swiperCarousel
				}

				_cacheEls() {
					this.carouselEl = this.querySelector('[data-main-carousel]')
					this.slideEls = this.carouselEl ? [...this.carouselEl.querySelectorAll('[data-media]')] : []
				}

				_onCarouselLoaded() {
					this._cacheEls()
					this._bindSwiper()
				}

				_bindSwiper() {
					if (!this.swiper || this._swiperBound) return

					this._swiperBound = true

					this.swiper.on('slideChange', () => this._onSlideChange())

					// Screen-based ratios resolve after header vars load, so autoHeight must re-measure
					const resizeObserver = new ResizeObserver(() => this.swiper?.updateAutoHeight(0))
					this.slideEls.forEach((slideEl) => resizeObserver.observe(slideEl))
					this._cleanups.push(() => resizeObserver.disconnect())

					this._syncModelSwipe()
					this._slideToFeatured()
					this._onSlideChange()
				}

				_onSlideChange() {
					const activeEl = this.swiper?.slides?.[this.swiper.activeIndex]

					this.slideEls.forEach((slideEl) => {
						if (slideEl === activeEl) return

						l_pauseAllMedia(slideEl)
						slideEl.querySelector('l-media-video')?.pauseVideo?.()
					})

					this._syncModelSwipe()
				}

				_slideToFeatured() {
					const featuredMediaId = this.dataset.featuredMediaId

					if (!featuredMediaId || !this.swiper) return

					const index = this.slideEls.findIndex((slideEl) => slideEl.dataset.mediaId == featuredMediaId)

					if (index > 0) this.swiper.slideTo(index, 0)
				}

				_onModelLoaded() {
					this._syncModelSwipe()
				}

				// Loaded 3D models own pointer drag; disable Swiper swipe on that slide only.
				_syncModelSwipe() {
					if (!this.swiper) return

					const slideEl = this.swiper.slides[this.swiper.activeIndex]

					this.swiper.allowTouchMove = !slideEl?.querySelector('l-product-model[data-loaded]')
				}

				_onVariantChange(event) {
					const { sectionId, productId, variant } = event.detail || {}

					if (productId !== this.dataset.productId || sectionId !== this.dataset.sectionId || !variant) return

					const featuredMediaId = variant.featured_media?.id

					if (!featuredMediaId) return

					const index = this.slideEls.findIndex((slideEl) => slideEl.dataset.mediaId == `${featuredMediaId}`)

					if (index < 0) return

					this.swiper?.slideTo(index)
				}
			}
		)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-membership-benefits"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-membership-benefits')) {
		class LTAMembershipBenefits extends HTMLElement {
			static LERP = 0.12
			static DWELL = 0.08
			static DRIFT = 0.008

			constructor() {
				super()
				this._measure = this._measure.bind(this)
				this._onScroll = this._onScroll.bind(this)
				this._onFrame = this._onFrame.bind(this)
				this._onResize = l_debounce(this._measure, 150)
			}

			/* -----------------------------------------------
			 * Lifecycle
			 * ----------------------------------------------- */
			connectedCallback() {
				this.pinEl = this.querySelector('[data-pan-pin]')
				this.viewEl = this.querySelector('[data-pan-view]')
				this.trackEl = this.querySelector('[data-pan-track]')
				this.railEl = this.querySelector('[data-pan-rail]') || this.viewEl

				if (!this.pinEl || !this.viewEl || !this.trackEl) return

				this.armed = false
				this.entered = false
				this.distance = 0
				this.current = 0
				this.target = 0
				this.frame = 0

				this.motion = window.matchMedia('(prefers-reduced-motion: reduce)')
				this.motion.addEventListener('change', this._measure)
				window.addEventListener('resize', this._onResize)

				this.observer = new ResizeObserver(() => {
					if (!this.armed) this._measure()
				})
				this.observer.observe(this.trackEl)
				this.observer.observe(this.viewEl)
			}

			disconnectedCallback() {
				this._disarm()
				this.observer?.disconnect()
				this.motion?.removeEventListener('change', this._measure)
				window.removeEventListener('resize', this._onResize)
				window.clearTimeout(this.enterTimer)
				this.removeAttribute('data-pan-enter')
			}

			/* -----------------------------------------------
			 * Measure — pan distance, pin offset, scroll start
			 * ----------------------------------------------- */
			_measure() {
				if (this.motion.matches) return this._disarm()

				const distance = Math.max(this.trackEl.scrollWidth, this.trackEl.offsetWidth) - this.viewEl.clientWidth

				if (distance < 1) return this._disarm()

				const viewportH = window.innerHeight
				const viewportMid = viewportH / 2
				const railRect = this.railEl.getBoundingClientRect()
				const railMid = railRect.top - this.viewEl.getBoundingClientRect().top + railRect.height / 2
				const pinTop = Math.round(viewportMid - railMid)

				this.distance = distance
				this.start = this.pinEl.getBoundingClientRect().top + window.scrollY + railMid - viewportMid

				this.style.setProperty('--l-pan-distance', Math.round(distance) + 'px')
				this.style.setProperty('--l-pin-top', pinTop + 'px')
				this.style.setProperty('--l-pin-min-h', viewportH - pinTop + 'px')

				this._arm()
				this._syncTarget()
				this.current = this.target
				this._write(this.current)
			}

			/* -----------------------------------------------
			 * Arm / disarm — scroll listener + pinned state
			 * ----------------------------------------------- */
			_arm() {
				if (this.armed) return

				this.armed = true
				this.setAttribute('data-pan', 'on')
				window.addEventListener('scroll', this._onScroll, { passive: true })
			}

			_disarm() {
				this.distance = 0
				this.current = 0
				this.target = 0
				this.trackEl?.style.removeProperty('translate')
				this.style.removeProperty('--l-pan-p')
				this.style.removeProperty('--l-pan-distance')
				this.style.removeProperty('--l-pin-top')
				this.style.removeProperty('--l-pin-min-h')
				this.removeAttribute('data-pan')

				if (this.armed) {
					this.armed = false
					window.removeEventListener('scroll', this._onScroll)
				}

				if (this.frame) {
					window.cancelAnimationFrame(this.frame)
					this.frame = 0
				}
			}

			/* -----------------------------------------------
			 * Scroll → eased target → lerped frame
			 * ----------------------------------------------- */
			_onScroll() {
				this._syncTarget()
				this._kick()
			}

			_kick() {
				if (!this.frame) this.frame = window.requestAnimationFrame(this._onFrame)
			}

			_onFrame() {
				this.frame = 0

				if (!this.distance) return

				const delta = this.target - this.current

				if (Math.abs(delta) < 0.00015) {
					this.current = this.target
					this._write(this.current)
					return
				}

				this.current += delta * LTAMembershipBenefits.LERP
				this._write(this.current)
				this._kick()
			}

			_syncTarget() {
				if (!this.distance) return

				this.raw = (window.scrollY - this.start) / this.distance
				this.progress = Math.min(1, Math.max(0, this.raw))
				this.target = LTAMembershipBenefits._ease(this.progress)
			}

			static _ease(t) {
				const { DWELL, DRIFT } = LTAMembershipBenefits

				if (t <= DWELL) return (t / DWELL) * DRIFT

				const u = (t - DWELL) / (1 - DWELL)

				return DRIFT + (1 - DRIFT) * u * u * u * (u * (u * 6 - 15) + 10)
			}

			_write(eased) {
				this.trackEl.style.translate = -(eased * this.distance).toFixed(2) + 'px'
				this.style.setProperty('--l-pan-p', eased.toFixed(4))

				if (this.progress > 0 && this.progress < 1 && !this.entered) {
					this.entered = true
					this.setAttribute('data-pan-enter', '')
					window.clearTimeout(this.enterTimer)
					this.enterTimer = window.setTimeout(() => this.removeAttribute('data-pan-enter'), 800)
				}

				if (this.raw <= 0 || this.raw >= 1) this.entered = false
			}
		}

		customElements.define('l-membership-benefits', LTAMembershipBenefits)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-philanthropy-partners"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-philanthropy-partners')) {
		class LTAPhilanthropyPartners extends HTMLElement {
			constructor() {
				super()
				this.onClick = this.onClick.bind(this)
				this.onKeydown = this.onKeydown.bind(this)
				this.onBlockSelect = this.onBlockSelect.bind(this)
			}

			connectedCallback() {
				this.tabs = [...this.querySelectorAll('[data-partners-tab]')]
				this.panels = [...this.querySelectorAll('[data-partners-panel]')]
				if (!this.tabs.length) return

				this.addEventListener('click', this.onClick)
				this.addEventListener('keydown', this.onKeydown)
				document.addEventListener('shopify:block:select', this.onBlockSelect)
			}

			disconnectedCallback() {
				this.removeEventListener('click', this.onClick)
				this.removeEventListener('keydown', this.onKeydown)
				document.removeEventListener('shopify:block:select', this.onBlockSelect)
			}

			onClick(event) {
				const tab = event.target.closest('[data-partners-tab]')
				if (tab) this.select(this.tabs.indexOf(tab))
			}

			onKeydown(event) {
				const index = this.tabs.indexOf(event.target.closest('[data-partners-tab]'))
				if (index < 0) return

				const last = this.tabs.length - 1
				const isRtl = getComputedStyle(this).direction === 'rtl'
				const prev = index === 0 ? last : index - 1
				const next = index === last ? 0 : index + 1
				let target

				switch (event.key) {
					case 'ArrowUp':
						target = prev
						break
					case 'ArrowDown':
						target = next
						break
					case 'ArrowLeft':
						target = isRtl ? next : prev
						break
					case 'ArrowRight':
						target = isRtl ? prev : next
						break
					case 'Home':
						target = 0
						break
					case 'End':
						target = last
						break
					default:
						return
				}

				event.preventDefault()
				this.select(target, true)
			}

			onBlockSelect(event) {
				if (event.detail?.sectionId !== this.dataset.sectionId) return

				const index = this.tabs.findIndex((tab) => tab.dataset.partnersTab === event.detail.blockId)
				if (index > -1) this.select(index)
			}

			select(index, focus = false) {
				this.tabs.forEach((tab, i) => {
					const isActive = i === index
					tab.classList.toggle('is-active', isActive)
					tab.setAttribute('aria-selected', String(isActive))
					tab.tabIndex = isActive ? 0 : -1
				})

				this.panels.forEach((panel, i) => {
					panel.classList.toggle('is-active', i === index)
				})

				if (focus) this.tabs[index].focus()
			}
		}

		customElements.define('l-philanthropy-partners', LTAPhilanthropyPartners)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations')) {
		class LTAProductRecommendations extends HTMLElement {
			constructor() {
				super()
				this._observer = null
			}

			connectedCallback() {
				if (!this.dataset.url) {
					this._finish(false)
					return
				}

				this._observer = new IntersectionObserver(
					(entries) => {
						if (!entries[0].isIntersecting) return
						this._observer.disconnect()
						this._load()
					},
					{ rootMargin: '0px 0px 400px 0px' }
				)
				this._observer.observe(this)
			}

			disconnectedCallback() {
				this._observer?.disconnect()
			}

			async _load() {
				let hasResults = false

				try {
					const response = await fetch(this.dataset.url)
					if (!response.ok) throw new Error(response.status)

					const doc = new DOMParser().parseFromString(await response.text(), 'text/html')
					const results = doc.querySelector('l-product-recommendations')
					const cards =
						results?.querySelectorAll(
							'[data-recommendations-source="api"] .l-cPCard, [data-recommendations-source="fallback"] .l-cPCard'
						) || []

					if (cards.length) {
						this.innerHTML = results.innerHTML
						hasResults = true
					}
				} catch (error) {
					console.error('[l-product-recommendations] failed:', error)
				}

				this._finish(hasResults)
			}

			_finish(hasResults) {
				if (!hasResults && !window.Shopify?.designMode) {
					this.closest('.shopify-section')?.classList.add('l-hidden')
					return
				}

				this.removeAttribute('data-loading')
			}
		}

		customElements.define('l-product-recommendations', LTAProductRecommendations)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-spotlight"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-spotlight')) {
		class LTAProductSpotlight extends HTMLElement {
			constructor() {
				super()
				this.init = this.init.bind(this)
				this.onThumbClick = this.onThumbClick.bind(this)
				this.onBlockSelect = this.onBlockSelect.bind(this)
			}

			connectedCallback() {
				this.mainEl = this.querySelector('[data-spotlight-main]')
				this.thumbsEl = this.querySelector('[data-spotlight-thumbs]')
				if (!this.mainEl || !this.thumbsEl) return

				if (window.Swiper) {
					this.init()
				} else {
					document.addEventListener('l:vendor:loaded', this.init, { once: true })
				}
			}

			disconnectedCallback() {
				document.removeEventListener('l:vendor:loaded', this.init)
				document.removeEventListener('shopify:block:select', this.onBlockSelect)
				this.thumbsEl?.removeEventListener('click', this.onThumbClick)
				this.main?.destroy()
				this.thumbs?.destroy()
				this.main = null
				this.thumbs = null
			}

			init() {
				if (this.main) return

				this.thumbButtons = [...this.thumbsEl.querySelectorAll('[data-spotlight-thumb]')]
				this.panels = [...this.querySelectorAll('[data-spotlight-panel]')]

				this.thumbs = new window.Swiper(this.thumbsEl, {
					direction: 'vertical',
					slidesPerView: 'auto',
					spaceBetween: 20,
					centerInsufficientSlides: true,
					watchSlidesProgress: true,
					freeMode: {
						enabled: true,
						sticky: false,
						momentumRatio: 0.5,
					},
					mousewheel: {
						forceToAxis: true,
						releaseOnEdges: true,
						sensitivity: 0.8,
					},
				})

				this.main = new window.Swiper(this.mainEl, {
					effect: 'fade',
					fadeEffect: { crossFade: true },
					speed: 500,
					grabCursor: true,
					keyboard: { enabled: true, onlyInViewport: true },
					thumbs: { swiper: this.thumbs, autoScrollOffset: 1 },
					on: { slideChange: () => this.sync() },
				})

				this.thumbsEl.addEventListener('click', this.onThumbClick)
				document.addEventListener('shopify:block:select', this.onBlockSelect)
				this.sync()
			}

			onThumbClick(event) {
				const button = event.target.closest('[data-spotlight-thumb]')
				if (button) this.main?.slideTo(this.thumbButtons.indexOf(button))
			}

			onBlockSelect(event) {
				if (event.detail?.sectionId !== this.dataset.sectionId) return

				const index = this.thumbButtons.findIndex((button) => button.dataset.spotlightThumb === event.detail.blockId)
				if (index > -1) this.main?.slideTo(index)
			}

			sync() {
				const active = this.main.activeIndex

				this.thumbButtons.forEach((button, index) => {
					button.setAttribute('aria-current', String(index === active))
				})

				this.panels.forEach((panel, index) => {
					panel.classList.toggle('is-active', index === active)
				})
			}
		}

		customElements.define('l-product-spotlight', LTAProductSpotlight)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-team-members"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-team-members')) {
		class LTATeamMembers extends HTMLElement {
			constructor() {
				super()
				this._onChipClick = this._onChipClick.bind(this)
				this._onChipKeydown = this._onChipKeydown.bind(this)
				this._onCardClick = this._onCardClick.bind(this)
				this._onCardKeydown = this._onCardKeydown.bind(this)
				this._onEditorRefresh = this._onEditorRefresh.bind(this)
				this._onCarouselLoaded = this._syncCarousel.bind(this)
				this._onMobileChange = this._syncMobileCardA11y.bind(this)
				this._activeFilter = 'all'
				this._mobileMq = window.matchMedia('(max-width: 767px)')
			}

			connectedCallback() {
				this.navEl = this.querySelector('[data-team-categories-nav]')
				this.listEl = this.querySelector('[data-team-categories]')
				this.gridEl = this.querySelector('[data-team-grid]')
				this.allLabel = (this.dataset.allLabel || 'All').trim() || 'All'

				if (!this.listEl || !this.gridEl) return

				this._bindCategories()
				this._syncMobileCardA11y()
				this.listEl.addEventListener('click', this._onChipClick)
				this.listEl.addEventListener('keydown', this._onChipKeydown)
				this.gridEl.addEventListener('click', this._onCardClick)
				this.gridEl.addEventListener('keydown', this._onCardKeydown)
				this.addEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded)

				if (this._mobileMq.addEventListener) {
					this._mobileMq.addEventListener('change', this._onMobileChange)
				} else if (this._mobileMq.addListener) {
					this._mobileMq.addListener(this._onMobileChange)
				}

				if (window.Shopify && window.Shopify.designMode) {
					document.addEventListener('shopify:section:load', this._onEditorRefresh)
					document.addEventListener('shopify:block:select', this._onEditorRefresh)
				}
			}

			disconnectedCallback() {
				if (this.listEl) {
					this.listEl.removeEventListener('click', this._onChipClick)
					this.listEl.removeEventListener('keydown', this._onChipKeydown)
				}
				if (this.gridEl) {
					this.gridEl.removeEventListener('click', this._onCardClick)
					this.gridEl.removeEventListener('keydown', this._onCardKeydown)
				}
				this.removeEventListener('l:swiper:carousel:loaded', this._onCarouselLoaded)

				if (this._mobileMq) {
					if (this._mobileMq.removeEventListener) {
						this._mobileMq.removeEventListener('change', this._onMobileChange)
					} else if (this._mobileMq.removeListener) {
						this._mobileMq.removeListener(this._onMobileChange)
					}
				}

				if (window.Shopify && window.Shopify.designMode) {
					document.removeEventListener('shopify:section:load', this._onEditorRefresh)
					document.removeEventListener('shopify:block:select', this._onEditorRefresh)
				}
			}

			_onEditorRefresh(event) {
				if (event && event.target && !event.target.contains(this) && event.target !== this) return
				this._bindCategories()
				this._syncMobileCardA11y()
				this._applyFilter(this._activeFilter)
			}

			_bindCategories() {
				this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-team-member]'))
				this._renderChips()
				this.chips = Array.prototype.slice.call(this.listEl.querySelectorAll('[data-team-filter]'))
			}

			_collectCategories() {
				const categories = new Map()

				this.cards.forEach((card) => {
					const handle = (card.dataset.category || '').trim()
					const label = (card.dataset.categoryLabel || '').trim()
					if (!handle || !label || categories.has(handle)) return
					categories.set(handle, label)
				})

				return categories
			}

			_renderChips() {
				const categories = this._collectCategories()
				const fragment = document.createDocumentFragment()

				if (categories.size === 0) {
					this.listEl.textContent = ''
					if (this.navEl) this.navEl.classList.add('l-hidden')
					this._syncCarousel()
					return
				}

				if (this.navEl) this.navEl.classList.remove('l-hidden')

				fragment.appendChild(this._createChip('all', this.allLabel, true))

				categories.forEach((label, handle) => {
					fragment.appendChild(this._createChip(handle, label, false))
				})

				this.listEl.textContent = ''
				this.listEl.appendChild(fragment)
				this._syncCarousel()
			}

			_createChip(handle, label, isActive) {
				const button = document.createElement('button')
				button.type = 'button'
				button.className = 'swiper-slide l-sTMembers__chip l-text l-leading-1' + (isActive ? ' is-active' : '')
				button.dataset.teamFilter = handle
				button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
				button.textContent = label
				return button
			}

			_syncCarousel() {
				const carousel = this.querySelector('l-swiper-carousel')
				if (!carousel || !carousel.swiperCarousel) return

				carousel.swiperSlideEls = carousel.querySelectorAll('.swiper-slide')
				carousel.swiperCarousel.update()
			}

			_onChipClick(event) {
				const chip = event.target.closest('[data-team-filter]')
				if (!chip || !this.listEl.contains(chip)) return

				event.preventDefault()
				this._setActiveChip(chip)
				this._applyFilter(chip.dataset.teamFilter || 'all')
			}

			_onChipKeydown(event) {
				if (event.key !== 'Enter' && event.key !== ' ') return

				const chip = event.target.closest('[data-team-filter]')
				if (!chip || !this.listEl.contains(chip)) return

				event.preventDefault()
				this._setActiveChip(chip)
				this._applyFilter(chip.dataset.teamFilter || 'all')
			}

			_setActiveChip(activeChip) {
				this.chips = Array.prototype.slice.call(this.listEl.querySelectorAll('[data-team-filter]'))
				this.chips.forEach((chip) => {
					const isActive = chip === activeChip
					chip.classList.toggle('is-active', isActive)
					chip.setAttribute('aria-pressed', isActive ? 'true' : 'false')
				})
			}

			_applyFilter(filter) {
				this._activeFilter = filter || 'all'
				const showAll = this._activeFilter === 'all'

				this.cards.forEach((card) => {
					const category = (card.dataset.category || '').trim()
					const match = showAll || category === this._activeFilter
					card.classList.toggle('l-hidden', !match)
				})
			}

			_isMobile() {
				return this._mobileMq && this._mobileMq.matches
			}

			_syncMobileCardA11y() {
				const mobile = this._isMobile()
				const cards = this.querySelectorAll('[data-team-member][data-drawer-selector]')

				cards.forEach((card) => {
					if (mobile) {
						card.setAttribute('role', 'button')
						card.setAttribute('tabindex', '0')
					} else {
						card.removeAttribute('role')
						card.removeAttribute('tabindex')
					}
				})
			}

			_openCardDrawer(card) {
				const selector = card && card.dataset.drawerSelector
				if (!selector) return

				const drawer = document.querySelector(selector)
				drawer?.drawer_open?.(card)
			}

			_onCardClick(event) {
				if (!this._isMobile()) return

				const card = event.target.closest('[data-team-member][data-drawer-selector]')
				if (!card || !this.gridEl.contains(card)) return

				event.preventDefault()
				this._openCardDrawer(card)
			}

			_onCardKeydown(event) {
				if (!this._isMobile()) return
				if (event.key !== 'Enter' && event.key !== ' ') return

				const card = event.target.closest('[data-team-member][data-drawer-selector]')
				if (!card || !this.gridEl.contains(card) || event.target !== card) return

				event.preventDefault()
				this._openCardDrawer(card)
			}
		}

		customElements.define('l-team-members', LTATeamMembers)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-vintage-downloads"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-vintage-downloads')) {
		class LTAVintageDownloads extends HTMLElement {
			constructor() {
				super()

				this._onChange = this._onChange.bind(this)
				this._onBlockSelect = this._onBlockSelect.bind(this)
			}

			connectedCallback() {
				this.selectEl = this.querySelector('[data-vintage-select]')

				if (!this.selectEl) return

				this.selectEl.addEventListener('change', this._onChange)
				document.addEventListener('shopify:block:select', this._onBlockSelect)
				this._show(this.selectEl.value)
			}

			disconnectedCallback() {
				this.selectEl?.removeEventListener('change', this._onChange)
				document.removeEventListener('shopify:block:select', this._onBlockSelect)
			}

			_onChange() {
				this._show(this.selectEl.value)
			}

			_onBlockSelect(event) {
				const blockId = event.detail?.blockId

				if (!blockId || !this.querySelector(`[data-vintage="${blockId}"]`)) return

				this.selectEl.value = blockId
				this._show(blockId)
			}

			_show(id) {
				this.querySelectorAll('[data-vintage]').forEach((el) => {
					el.hidden = el.dataset.vintage !== id
				})
			}
		}

		customElements.define('l-vintage-downloads', LTAVintageDownloads)
	}

  } catch(e) { console.error(e); }
})();
})();
